import ArrowDownIcon from './icons/ArrowDownIcon';

const Accordion = (props) => {
  const { activeItem, index, title, children, onClick } = props;

  return (
    <div
      className={`relative z-10 transition-all overflow-hidden`}
    >
      <div className="cursor-pointer pt-8 flex items-center justify-between gap-4 w-full" onClick={() => onClick(index)}>
        <div className='text-green-400 font-medium text-lg'>{title}</div>
        <ArrowDownIcon className={`${activeItem === index ? '-rotate-180' : 'rotate-0'} duration-200`} color="#163317" />
      </div>
      <div className={`grid text-green-400 text-sm relative overflow-hidden transition-all duration-300 ${activeItem === index ? 'mt-5 grid-rows-[1fr]' : 'grid-rows-[0fr] mt-0'}`}><div className='overflow-hidden'>{children}</div></div>
    </div>
  );
};

export default Accordion;
